import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ZonesFilters } from '../../../commons/models/zone';
import { TenantsDTO } from '../../../commons/models/tenants';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store/reducers';
import { getTenants } from '../../../store/selectors/tenant.selectors';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-zones-filters',
  templateUrl: './zones-filters.component.html',
  styleUrls: ['./zones-filters.component.scss']
})
export class ZonesFiltersComponent {
  private unsubscribe$ = new Subject<void>();
  tenants: TenantsDTO[] = [] 

  @Output()
  onFilter: EventEmitter<ZonesFilters> = new EventEmitter();

  private _defaultFilters: ZonesFilters;
  filtersForm: FormGroup;

  constructor(private fb: FormBuilder, private store$: Store<AppState>) {
    this._createForm();
    this.store$
      .select(getTenants)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((tenantsDTO: TenantsDTO[]) => {
        this.tenants = tenantsDTO;
      });
  }  

  private _createForm() {
    let group = {
      search: "",
      tenant_id: null,
    }

    this.filtersForm = this.fb.group(group);
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  applyFilters() {
    this.onFilter.emit(this._getFilters());
  }

  private _getFilters(): ZonesFilters {
    let filters: ZonesFilters = {}
    if (this.filtersForm) {
      const values = this.filtersForm.value;
      filters.search = values.search;
      filters.tenant_id = values.tenant_id;
    }
    return filters;
  }

  resetFilters() {
    this.filtersForm.reset();
    this.filtersForm.patchValue({
      search: "",
      tenant_id: null,
    });
    this._setDefaultValues();
    this.applyFilters();
  }

  get defaultFilters(): ZonesFilters {
    return this._defaultFilters;
  }

  @Input()
  set defaultFilters(defaultFilters: ZonesFilters) {
    this._defaultFilters = defaultFilters;
    this._setDefaultValues();
  }

  private _setDefaultValues() {
    if (this.defaultFilters) {
      if (this.filtersForm) {
        this.filtersForm.patchValue({
          search: this.defaultFilters.search,
          tenant_id: this.defaultFilters.tenant_id,
        })
      }
    }
  }
}
